import { Modal } from "@mui/material";
import useStyles from "./styles";
import EditCadastroCliente from "../tabEditCadastro";

export default function ModalEditCadastro(params) {
  const {
    openEditModal,
    setOpenEditModal,
    selectedRow,
    setSelectedRow,
    handleUpdatedClient,
    setSnackbar,
  } = params;
  const styles = useStyles();

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }

  return (
    <Modal
      open={openEditModal}
      onClose={() => {
        setOpenEditModal(false);
      }}
      sx={styles.modal}
    >
      <EditCadastroCliente
        openEditModal={openEditModal}
        setOpenEditModal={setOpenEditModal}
        selectedRow={selectedRow}
        setSelectedRow={setSelectedRow}
        handleUpdatedClient={handleUpdatedClient}
        setSnackbar={setSnackbar}
      />
    </Modal>
  );
}
